export default __webpack_public_path__ + "static/media/white-blue-tick.ba3a75ca.svg";